import React, { useContext, useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  KeyboardAvoidingView,
} from "react-native";
import { Avatar } from "react-native-elements";
import { useNavigation } from "@react-navigation/native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

import {
  ButtonAddRoute,
  TextAddRoute,
  Content,
  TextTitlePage,
  ContainerButton,
} from "./styles";
import { Header, Container, TextField, Button } from "../../../components";
import ClientContext from "../../../context/client";

function AddClientAdmin({ route }) {
  const navigation = useNavigation();
  const { clients, registerClient, getClients, updateDataClient } =
    useContext(ClientContext);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [numberAddress, setNumberAddress] = useState("");
  const [complement, setComplement] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [documentId, setDocumentId] = useState("");
  const [observation, setObservation] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (route.params.edit) {
      const filteredClients = clients.filter(
        (element: any) => element.id === route.params.id
      );
      setName(filteredClients[0].name ?? "");
      setPhone(filteredClients[0].phone ?? "");
      setEmail(filteredClients[0].email ?? "");
      setAddress(filteredClients[0].address ?? "");
      setNumberAddress(filteredClients[0].number ?? "");
      setComplement(filteredClients[0].complement ?? "");
      setState(filteredClients[0].state ?? "");
      setCity(filteredClients[0].city ?? "");
      setDocumentId(filteredClients[0].document_id ?? "");
      setObservation(filteredClients[0].observation ?? "");
    }
  }, []);

  async function onSubmit() {
    setLoading(true);
    const data = {
      name,
      phone,
      email,
      address,
      number: numberAddress,
      complement,
      state,
      city,
      document_id: documentId,
      observation,
    };

    try {
      if (route.params.edit) {
        await updateDataClient(data, route.params.id);
      } else {
        await registerClient(data);
      }
      await getClients();
      setLoading(false);
      navigation.navigate("ReportAdmin", {});
    } catch (_) {
      console.log("registerClient error screen");
      setLoading(false);
    }
  }

  return (
    <Container>
      <Header
        name="Bruno Morais"
        type="simple"
        title={route.params.edit ? "Editar cliente" : "Adicionar cliente"}
      />
      <Content>
        <KeyboardAwareScrollView>
          <TextTitlePage>
            {route.params.edit ? "Editar cliente" : "Adicionar novo cliente"}
          </TextTitlePage>
          <View>
            <TextField
              label="Nome do cliente"
              placeholder="Digite seu nome"
              value={name}
              onChangeText={(text: string) => setName(text)}
            />
          </View>
          <View>
            <TextField
              label="Telefone"
              placeholder="Digite seu nome"
              value={phone}
              mask="cel-phone"
              keyboardType="number-pad"
              onChangeText={(text: string) => setPhone(text)}
            />
          </View>
          <View>
            <TextField
              label="E-mail"
              placeholder="Digite seu nome"
              value={email}
              keyboardType="email-address"
              onChangeText={(text: string) => setEmail(text)}
            />
          </View>
          <View>
            <TextField
              label="Endereço"
              placeholder="Digite seu nome"
              value={address}
              onChangeText={(text: string) => setAddress(text)}
            />
          </View>
          <View>
            <TextField
              label="Número"
              placeholder="Digite seu nome"
              value={numberAddress}
              keyboardType="number-pad"
              onChangeText={(text: string) => setNumberAddress(text)}
            />
          </View>
          <View>
            <TextField
              label="Complemento"
              placeholder="Digite seu nome"
              value={complement}
              onChangeText={(text: string) => setComplement(text)}
            />
          </View>
          <View>
            <TextField
              label="Estado"
              placeholder="Digite seu nome"
              value={state}
              onChangeText={(text: string) => setState(text)}
            />
          </View>
          <View>
            <TextField
              label="Cidade"
              placeholder="Digite seu nome"
              value={city}
              onChangeText={(text: string) => setCity(text)}
            />
          </View>
          <View>
            <TextField
              label="CNPJ"
              placeholder="Digite seu nome"
              value={documentId}
              mask="cnpj"
              keyboardType="number-pad"
              onChangeText={(text: string) => setDocumentId(text)}
            />
          </View>
          <View>
            <TextField
              label="Observação"
              placeholder="Digite seu nome"
              value={observation}
              onChangeText={(text: string) => setObservation(text)}
            />
          </View>

          <ContainerButton>
            <Button
              title={route.params.edit ? "Atualizar" : "Cadastrar"}
              loading={loading}
              onPress={onSubmit}
              disabled={!name || !phone || !email || !address || !numberAddress || !complement || !state || !city || !documentId}
            />
          </ContainerButton>
        </KeyboardAwareScrollView>
      </Content>
    </Container>
  );
}

export default AddClientAdmin;
